







import { Component, Vue } from "vue-property-decorator";
import LoginInput from "@/components/LoginInput.vue";
import FloatingInner from "@/layouts/FloatingInner.vue";

@Component({
  components: {
    LoginInput,
    FloatingInner
  }
})
export default class Login extends Vue {
  async login(props: { company: string; username: string; password: string }) {
    try {
      await this.$store.dispatch("app/login", props);
    } catch (e) {
      alert("ログインできませんでした");
      return;
    }
    this.$router.push(this.redirectPath);
  }

  get subDomain(): string {
    if (process.env.VUE_APP_DEFAULT_COMPANY_ID) {
      return process.env.VUE_APP_DEFAULT_COMPANY_ID;
    }
    return location.hostname.split(".")[0] || "";
  }

  get redirectPath(): string {
    if (this.$route.query.path) {
      return this.$route.query.path as string;
    }

    return "/";
  }
}
